<template lang="pug">
  router-view
</template>

<script>
export default {
  name: 'LayoutBasic',
  components: {
  },
  data() {
    return {

    };
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/layout/LayoutBasic.vue